<template>
    <div></div>
</template>

<script>
    import * as d3 from 'd3'

    export default {
      name: 'activityBarGraph',
      props: ['activities', 'xAxisLabel', 'yAxisLabel'],
      data: () => {
        return {}
      },

      mounted () {
        if (this.activities.length > 0) {
          this.generateBarChart(this.activities)
        }
        let self = this
        this.$nextTick(function () {
          window.addEventListener('resize', function (e) {
            self.generateBarChart(self.activities)
          })
        })
      },

      watch: {
        activities () {
          if (this.activities.length > 0) {
            this.generateBarChart(this.activities)
          }
        }
      },

      methods: {
        generateBarChart (data) {
          $(this.$el).empty()
          if (data && data.length > 0) {
            const margin = {top: 10, right: 10, bottom: 105, left: 50}
            const width = (data.length * 50) + 20
            const height = 200 - margin.top - margin.bottom

            var x = d3.scaleBand().rangeRound([0, data.length * 50]).padding(0.05)
            x.domain(data.map(function (d) { return d.name }))
            var xAxis = d3.axisBottom().scale(x).tickSize(0)

            var y = d3.scaleLinear().rangeRound([height, 0])
            var yAxis = d3.axisLeft().scale(y).tickSize(0).tickFormat(d3.format('d')).ticks(3)

            var svg = d3.select(this.$el).append('svg')
            .attr('width', width)
            .attr('height', (margin.top + margin.bottom))
            .append('g')
            .attr('transform', 'translate(' + (margin.left - 20) + ',' + margin.top + ')')

            data.forEach(function (d) {
              d.yAxisValue = +d.count
            })

            y.domain([0, d3.max(data, function (d) {
              return (d.yAxisValue < 1) ? 1 : d.yAxisValue
            })]).nice()

            const top = y.domain()[1]
            if (top < 3) {
              if (top === 1) {
                yAxis.ticks(1)
              } else {
                yAxis.ticks(2)
              }
            }

            svg.append('g')
            .attr('class', 'x axis')
            .call(xAxis)
            .attr('transform', 'translate(0,' + height + ')')
            .selectAll('text')
            .text(function (d) {
              return d
            })
            .attr('x', -3)
            .attr('dy', '1em')
            .style('font-size', '0.7vmax')
            .style('text-anchor', 'middle')

            svg.append('g')
            .attr('class', 'y axis')
            .call(yAxis)
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - ((margin.left + 10) / 2))
            .attr('x', 0 - (height / 2))
            .attr('dy', '1em')
            .style('fill', 'black')
            .style('text-anchor', 'middle')
            .text(this.yAxisLabel)

            svg.selectAll('.bar')
            .data(data)
            .enter().append('rect')
            .attr('class', function (d, i) {
              return (d.isShowShadow) ? 'bar shadow' : 'bar'
            })
            .attr('x', function (d) { return x(d.name) })
            .attr('y', function (d) { return y(d.yAxisValue) })
            .attr('width', (x.bandwidth() - 5))
            .attr('height', function (d) { return height - y(d.yAxisValue) })
            .style('fill', function (d, i) {
              return d.color
            })
          } else {
            $(this.$el).html('No activity found!')
          }
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/app/course/components/ActivityBarGraph.vue